import * as api from "../Services/api";
import ClientRoster from "../../objs/ClientRoster";
import Plan from "../../objs/Plan";
import Assignment from "../../objs/Assignment";
import CustomWorkview from "../../objs/CustomWorkview";

function deepCompare(obj1, obj2) {
  // 1. Check for strict equality (primitives, same reference)
  if (obj1 === obj2) return true;

  // 2. Check for null or different types (objects vs non-objects)
  if (
    obj1 == null ||
    obj2 == null ||
    typeof obj1 !== "object" ||
    typeof obj2 !== "object"
  ) {
    return false;
  }

  // 3. Handle Arrays
  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    if (obj1.length !== obj2.length) return false;
    // Use .every() to iterate and recursively compare each element
    return obj1.every((item, index) => deepCompare(item, obj2[index]));
  } else if (Array.isArray(obj1) || Array.isArray(obj2)) {
    return false; // One is an array, the other isn't
  }

  // 4. Handle Objects
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  // Iterate over keys and recursively compare values
  for (const key of keys1) {
    if (!keys2.includes(key) || !deepCompare(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}
export const state = {
  clientRoster: [],
  latestRosterRequestId: 0,
  currentRosterController: null,
  plans: [],
  filters: {
    clientFilter: {},
    yearOfBirthFilter: {},
    districtFilter: [],
    districtAdminFilter: {},
    schoolFilter: {},
    teamFilter: {},
    locationFilter: {},
    programFilter: {},
    serviceFilter: {},
    groupSizeFilter: {},
    tenTwelveMonthFilter: {},
    nextMeetingScheduledFilter: {},
    languageFilter: {},
    semesterFilter: {},
    providerFilter: {},
    zipCodeFilter: [],
    planStartDateFilter: [],
    planEndDateFilter: [],
    actualStartDateFilter: [],
    activePlansFilter: true,
    expiringPlansFilter: false,
    pendingAssignmentsFilter: false,
    partialMandateFilter: false,
    pendingApprovalFilter: false,
    awaitingFADSubmissionFilter: false,
    currentAssignmentsFilter: false,
  },
  displayColumns: [],
  customWorkviews: [],
  selectedCustomWorkview: null,
};
export const mutations = {
  SET_CLIENT_ROSTER(state, payload) {
    state.clientRoster = payload
      ? payload.map((item) => new ClientRoster(item))
      : [];
  },
  UPDATE_CLIENT_ROSTER(state, payload) {
    state.clientRoster = state.clientRoster.map((item) => {
      return item.servicePlanId == payload.servicePlanId
        ? new ClientRoster(payload)
        : item;
    });
  },
  SET_PLANS(state, payload) {
    state.plans = payload ? payload.map((item) => new Plan(item)) : [];
  },
  ADD_PLAN(state, payload) {
    state.plans.push(new Plan(payload));
  },
  UPDATE_PLAN(state, payload) {
    state.plans = state.plans.map((item) => {
      return item.planId == payload.planId ? new Plan(payload) : item;
    });
  },
  DELETE_PLAN(state, planId) {
    var index = state.plans.findIndex((item) => item.planId == planId);
    state.plans.splice(index, 1);
  },
  ADD_PROVIDER_ASSIGNMENT(state, payload) {
    var plan = state.plans.find((item) =>
      item.servicePlans.some(
        (innerItem) => innerItem.servicePlanId == payload.servicePlanId
      )
    );
    var servicePlan = plan.servicePlans.find(
      (item) => item.servicePlanId == payload.servicePlanId
    );
    servicePlan.assignments.push(new Assignment(payload));
  },
  UPDATE_PROVIDER_ASSIGNMENT(state, payload) {
    var plan = state.plans.find((item) =>
      item.servicePlans.some(
        (item) => item.servicePlanId == payload.servicePlanId
      )
    );
    var servicePlan = plan.servicePlans.find(
      (item) => item.servicePlanId === payload.servicePlanId
    );
    var index = servicePlan.assignments.findIndex(
      (item) => item.assignmentId === payload.assignmentId
    );
    servicePlan.assignments.splice(index, 1, new Assignment(payload));
  },
  DELETE_ASSIGNMENT(state, assignmentId) {
    var plan = state.plans.find((plan) =>
      plan.servicePlans.some((servicePlan) =>
        servicePlan.assignments.some(
          (innerItem) => innerItem.assignmentId == assignmentId
        )
      )
    );
    var servicePlan = plan.servicePlans.find((item) =>
      item.assignments.some((item) => item.assignmentId == assignmentId)
    );
    var index = servicePlan.assignments.findIndex(
      (item) => item.assignmentId === assignmentId
    );
    servicePlan.assignments.splice(index, 1);
  },
  SET_FILTERS(state, payload) {
    state.filters[payload.filterName] = payload.filterValue;
  },
  CLEAR_FILTERS(state) {
    state.filters = {
      clientFilter: {},
      yearOfBirthFilter: {},
      districtFilter: [],
      districtAdminFilter: {},
      schoolFilter: {},
      teamFilter: {},
      locationFilter: {},
      programFilter: {},
      serviceFilter: {},
      groupSizeFilter: {},
      tenTwelveMonthFilter: {},
      nextMeetingScheduledFilter: {},
      languageFilter: {},
      semesterFilter: {},
      providerFilter: {},
      zipCodeFilter: [],
      planStartDateFilter: [],
      planEndDateFilter: [],
      actualStartDateFilter: [],
      activePlansFilter: true,
      expiringPlansFilter: false,
      pendingAssignmentsFilter: false,
      partialMandateFilter: false,
      pendingApprovalFilter: false,
      awaitingFADSubmissionFilter: false,
      currentAssignmentsFilter: false,
    };
  },
  SET_DISPLAY_COLUMNS(state, payload) {
    state.displayColumns = payload;
  },
  SET_CUSTOM_WORKVIEWS(state, payload) {
    state.customWorkviews = payload.map((item) => new CustomWorkview(item));
  },
  ADD_CUSTOM_WORKVIEW(state, payload) {
    state.customWorkviews.push(new CustomWorkview(payload));
  },
  DELETE_CUSTOM_WORKVIEW(state, customWorkviewId) {
    var index = state.customWorkviews.findIndex(
      (item) => item.customWorkviewId === customWorkviewId
    );
    state.customWorkviews.splice(index, 1);
  },
  UPDATE_CUSTOM_WORKVIEW(state, payload) {
    var index = state.customWorkviews.findIndex(
      (item) => item.customWorkviewId === payload.customWorkviewId
    );
    state.customWorkviews.splice(index, 1, new CustomWorkview(payload));
  },
  SET_SELECTED_CUSTOM_WORKVIEW(state, payload) {
    state.selectedCustomWorkview = new CustomWorkview({
      ...payload,
      configuration: JSON.parse(payload.configuration),
    });
    // manually parse dates
    var dateFilters = state.selectedCustomWorkview.configuration.filters.filter(
      (x) =>
        x.filterName === "planStartDateFilter" ||
        x.filterName === "planEndDateFilter" ||
        x.filterName === "actualStartDateFilter"
    );
    dateFilters.forEach((item) => {
      item.filterValue.forEach((innerItem) => {
        innerItem.id = new Date(innerItem.id);
      });
    });
  },
  CLEAR_SELECTED_CUSTOM_WORKVIEW(state) {
    state.selectedCustomWorkview = null;
  },
};
export const getters = {
  getFilteredRoster(state) {
    var roster = state.clientRoster.filter((x) => {
      return (
        (!Boolean(state.filters.clientFilter.id) ||
          x.clientId == state.filters.clientFilter.id) &&
        (!Boolean(state.filters.yearOfBirthFilter.id) ||
          x.yearOfBirth == state.filters.yearOfBirthFilter.id) &&
        (!Boolean(state.filters.districtFilter.length) ||
          state.filters.districtFilter.some((item) => {
            return x.districtId == item.id;
          })) &&
        (!Boolean(state.filters.districtAdminFilter.id) ||
          x.districtAdminId == state.filters.districtAdminFilter.id) &&
        (!Boolean(state.filters.schoolFilter.id) ||
          (x.schoolId == null && state.filters.schoolFilter.id == "none") ||
          x.schoolId == state.filters.schoolFilter.id) &&
        (!Boolean(state.filters.teamFilter.id) ||
          (x.teamId == null && state.filters.teamFilter.id == "none") ||
          x.teamId == state.filters.teamFilter.id) &&
        (!Boolean(state.filters.locationFilter.id) ||
          x.sessionLocationId == state.filters.locationFilter.id) &&
        (!Boolean(state.filters.programFilter.length) ||
          state.filters.programFilter.some((item) => {
            return x.programId == item.id;
          })) &&
        (!Boolean(state.filters.serviceFilter.length) ||
          state.filters.serviceFilter.some((item) => {
            return x.serviceId == item.id;
          })) &&
        (!Boolean(state.filters.groupSizeFilter.id) ||
          x.groupSize == state.filters.groupSizeFilter.id) &&
        (!Boolean(state.filters.tenTwelveMonthFilter.id) ||
          x.tenTwelveMonth === state.filters.tenTwelveMonthFilter.id) &&
        (!Boolean(state.filters.nextMeetingScheduledFilter.id) ||
          (state.filters.nextMeetingScheduledFilter.id == "scheduled") ==
            Boolean(x.nextMeetingScheduledDate)) &&
        (!Boolean(state.filters.languageFilter.id) ||
          x.languageId == state.filters.languageFilter.id) &&
        (!Boolean(state.filters.semesterFilter.id) ||
          x.semesterCode == state.filters.semesterFilter.id) &&
        (!Boolean(state.filters.providerFilter.id) ||
          (x.providerId == null && state.filters.providerFilter.id == "none") ||
          x.providerId == state.filters.providerFilter.id) &&
        (!Boolean(state.filters.zipCodeFilter.length) ||
          state.filters.zipCodeFilter.some((item) => {
            return x.zipCode == item.id;
          })) &&
        // date filters
        (!Boolean(state.filters.planStartDateFilter.length) ||
          state.filters.planStartDateFilter.some((item) => {
            return (
              new Date(x.servicePlanStartDate).getMonth() ==
                item.id.getMonth() &&
              new Date(x.servicePlanStartDate).getFullYear() ==
                item.id.getFullYear()
            );
          })) &&
        (!Boolean(state.filters.planEndDateFilter.length) ||
          state.filters.planEndDateFilter.some((item) => {
            return (
              new Date(x.servicePlanEndDate).getMonth() == item.id.getMonth() &&
              new Date(x.servicePlanEndDate).getFullYear() ==
                item.id.getFullYear()
            );
          })) &&
        (!Boolean(state.filters.actualStartDateFilter.length) ||
          state.filters.actualStartDateFilter.some((item) => {
            return (
              new Date(x.actualStartDate).getMonth() == item.id.getMonth() &&
              new Date(x.actualStartDate).getFullYear() == item.id.getFullYear()
            );
          })) &&
        (state.filters.activePlansFilter === false || x.isActivePlan) &&
        (state.filters.expiringPlansFilter === false ||
          x.isExpiringServicePlan ||
          x.isExpiringAssignment) &&
        (state.filters.pendingAssignmentsFilter === false ||
          x.isPendingAssignment) &&
        (state.filters.partialMandateFilter === false || x.isPartialMandate) &&
        (state.filters.pendingApprovalFilter === false ||
          x.isPendingApproval) &&
        (state.filters.awaitingFADSubmissionFilter === false ||
          x.isAwaitingFADSubmission) &&
        (state.filters.currentAssignmentsFilter === false ||
          x.isCurrentAssignment)
      );
    });
    return roster;
  },
  getHasActivePlans(state) {
    return state.plans.some((x) => x.isActive == 1);
  },
  getAppliedFilters(state) {
    // retrieves all the filters that have a value and maps them
    return Object.entries(state.filters)
      .filter(([_, value]) => {
        if (Array.isArray(value)) return value.length > 0;
        if (value && typeof value === "object")
          return Object.keys(value).length > 0;
        return Boolean(value);
      })
      .map(([filterName, filterValue]) => ({ filterName, filterValue }));
  },
  isFiltersDirty(state, getters) {
    return (
      Boolean(state.selectedCustomWorkview) &&
      (state.selectedCustomWorkview.configuration.filters?.length !=
        getters.getAppliedFilters.length ||
        !getters.getAppliedFilters.every((item) =>
          state.selectedCustomWorkview.configuration.filters.some(
            (filter) =>
              filter.filterName == item.filterName &&
              deepCompare(item.filterValue, filter.filterValue)
          )
        ))
    );
  },
  isColumnsDirty(state) {
    return (
      Boolean(state.selectedCustomWorkview) &&
      (state.selectedCustomWorkview.configuration.display?.length !=
        state.displayColumns.length ||
        !state.selectedCustomWorkview.configuration.display.every((item) =>
          state.displayColumns.some((column) => item == column)
        ))
    );
  },
};

// Start a new abortable roster request and cancel any prior pending request.
// This ensures only the latest request can commit the client roster state.
function createAbortableRosterRequest() {
  if (state.currentRosterController) {
    try {
      state.currentRosterController.abort();
    } catch (e) {}
  }
  const controller = new AbortController();
  state.currentRosterController = controller;
  return { controller, requestId: ++state.latestRosterRequestId };
}

function isCanceledResponse(response) {
  return (
    response &&
    (response.name === "CanceledError" || response.code === "ERR_CANCELED")
  );
}

// Keep only the most recent response and ignore any stale or canceled result.
function handleRosterResponse(requestId, response, commit) {
  if (requestId !== state.latestRosterRequestId) {
    return response.success;
  }
  if (isCanceledResponse(response)) {
    return false;
  }
  if (response.success) {
    commit("SET_CLIENT_ROSTER", response.data);
  }
  return response.success;
}

export const actions = {
  async getCustomWorkviewsForUser({ commit }) {
    return api.get("/plan/getCustomWorkviewsForUser").then((response) => {
      if (response.success) {
        commit("SET_CUSTOM_WORKVIEWS", response.data);
      }
      return response.success;
    });
  },
  async createCustomWorkview({ commit, getters, state }, data) {
    const customWorkview = {
      name: data.name,
      configuration: JSON.stringify({
        filters: getters.getAppliedFilters,
        display: state.displayColumns,
      }),
      programView: data.programView,
    };
    return api
      .post("/plan/createCustomWorkview", customWorkview)
      .then((response) => {
        if (response.success) {
          commit("ADD_CUSTOM_WORKVIEW", response.data);
          commit("SET_SELECTED_CUSTOM_WORKVIEW", response.data);
        }
        return response.success;
      });
  },
  async updateCustomWorkview({ commit, getters, state }, data) {
    var appliedFilters = getters.getAppliedFilters;
    const customWorkview = {
      ...state.selectedCustomWorkview,
      name: data,
      configuration: JSON.stringify({
        filters: appliedFilters,
        display: state.displayColumns,
      }),
    };
    return api
      .post("/plan/updateCustomWorkview", customWorkview)
      .then((response) => {
        if (response.success) {
          commit("UPDATE_CUSTOM_WORKVIEW", response.data);
          commit("SET_SELECTED_CUSTOM_WORKVIEW", response.data);
        }
        return response.success;
      });
  },
  async deleteCustomWorkview({ commit }, data) {
    return api
      .postQuery("/plan/deleteCustomWorkview", { customWorkviewId: data })
      .then((response) => {
        if (response.success) {
          commit("DELETE_CUSTOM_WORKVIEW", data);
          commit("CLEAR_SELECTED_CUSTOM_WORKVIEW");
          commit("CLEAR_FILTERS");
          return "";
        }
        return response.message;
      });
  },
  clearClientRoster({ commit }) {
    commit("SET_CLIENT_ROSTER", []);
  },
  async getClientRoster({ commit }, data) {
    const { controller, requestId } = createAbortableRosterRequest();
    return api
      .getQuery("/plan/getClientRoster", data, {
        signal: controller.signal,
        // repeat plain keys (programIds=3&programIds=8) so array binds to List<long> in ASP.NET Core
        paramsSerializer: { indexes: null },
      })
      .then((response) => handleRosterResponse(requestId, response, commit))
      .finally(() => {
        if (state.currentRosterController === controller)
          state.currentRosterController = null;
      });
  },
  cancelCurrentRosterRequest() {
    if (state.currentRosterController) {
      try {
        state.currentRosterController.abort();
      } catch (e) {}
      state.currentRosterController = null;
    }
  },
  async getPlansByClient({ commit }, data) {
    return await api
      .getQuery("/plan/getPlansByClient", { clientId: data })
      .then((response) => {
        if (response.success) {
          commit("SET_PLANS", response.data);
        } else {
          commit("SET_PLANS", []);
        }
        return response.success;
      });
  },
  async updatePlan({ commit }, data) {
    return await api.post("/plan/updatePlan", data).then((response) => {
      if (response.success) {
        commit("UPDATE_PLAN", response.data);
        return "";
      }
      return response.message;
    });
  },
  // Atomically create or update a plan together with its service plans in a single request
  async savePlan({ commit, dispatch, rootState }, data) {
    const isNew = !data.planId;
    return await api.post("/plan/savePlan", data).then((response) => {
      if (response.success) {
        commit(isNew ? "ADD_PLAN" : "UPDATE_PLAN", response.data);
        // service plans can be added/removed here, so refresh the client
        dispatch(
          "clientModule/getClient",
          rootState.clientModule.selectedClient.clientId,
          {
            root: true,
          }
        );
        return "";
      }
      return response.message;
    });
  },
  async deletePlan({ commit, dispatch, rootState }, data) {
    return await api.postQuery("/plan/deletePlan", data).then((response) => {
      if (response.success) {
        commit("DELETE_PLAN", data.planId);
        dispatch(
          "clientModule/getClient",
          rootState.clientModule.selectedClient.clientId,
          {
            root: true,
          }
        );
        return "";
      }
      return response.message;
    });
  },
  async createProviderAssignment({ commit }, data) {
    return await api.post("/plan/createAssignment", data).then((response) => {
      if (response.success) {
        commit("ADD_PROVIDER_ASSIGNMENT", response.data);
        return "";
      }
      return response.message;
    });
  },
  async updateProviderAssignment({ commit, dispatch, rootState }, data) {
    return await api.post("/plan/updateAssignment", data).then((response) => {
      if (response.success) {
        commit("UPDATE_PROVIDER_ASSIGNMENT", response.data);
        dispatch(
          "clientModule/getClient",
          rootState.clientModule.selectedClient.clientId,
          {
            root: true,
          }
        );
        return "";
      }
      return response.message;
    });
  },
  async deleteProviderAssignment({ commit, dispatch, rootState }, data) {
    return await api
      .postQuery("/plan/deleteAssignment", data)
      .then((response) => {
        if (response.success) {
          commit("DELETE_ASSIGNMENT", data.assignmentId);
          dispatch(
            "clientModule/getClient",
            rootState.clientModule.selectedClient.clientId,
            {
              root: true,
            }
          );
          return "";
        }
        return response.message;
      });
  },
  async getAssignmentsForProvider({ commit }, data) {
    return await api
      .getQuery("/plan/getAssignmentsForProvider", { providerId: data })
      .then((response) => {
        if (response.success) {
          return response.data.map((item) => new Assignment(item));
        }
        return [];
      });
  },
  async getMyAssignments({ commit }, data) {
    return await api
      .getQuery("/plan/getMyAssignments", { providerId: data })
      .then((response) => {
        if (response.success) {
          return response.data.map((item) => new Assignment(item));
        }
        return [];
      });
  },
  async importAction({ commit }, data) {
    var response = await api.postQuery("/bOEImport/importSingleAction", data);
    if (response.success) {
      commit("UPDATE_PROVIDER_ASSIGNMENT", response.data);
      return "";
    } else {
      return response.message;
    }
  },
  async setFADSubmitted({ commit }, data) {
    return await api
      .postQuery("/plan/setFADSubmitted", data)
      .then((response) => {
        if (response.success) {
          response.data.map((item) => commit("UPDATE_CLIENT_ROSTER", item));
          return "";
        }
        return response.message;
      });
  },
  async setAssignmentFADSubmitted({ commit }, data) {
    return await api
      .postQuery("/plan/setAssignmentFADSubmitted", data)
      .then((response) => {
        if (response.success) {
          response.data.map((item) => commit("UPDATE_CLIENT_ROSTER", item));
          return "";
        }
        return response.message;
      });
  },
  async sendAssignmentNotification({ commit }, data) {
    return await api
      .postQuery("/plan/sendAssignmentNotification", data)
      .then((response) => {
        if (response.success) {
          commit("UPDATE_PROVIDER_ASSIGNMENT", response.data);
          return "";
        }
        return response.message;
      });
  },
  setFilters({ commit }, data) {
    commit("SET_FILTERS", data);
  },
  clearFilters({ commit }) {
    commit("CLEAR_FILTERS");
  },
  setDisplayColumns({ commit }, data) {
    commit("SET_DISPLAY_COLUMNS", data);
  },
  setSelectedCustomWorkview({ commit, state }, data) {
    commit("SET_SELECTED_CUSTOM_WORKVIEW", data);
    commit(
      "SET_DISPLAY_COLUMNS",
      state.selectedCustomWorkview.configuration.display
    );
    state.selectedCustomWorkview.configuration.filters.forEach((item) =>
      commit("SET_FILTERS", item)
    );
  },
  clearSelectedCustomWorkview({ commit }) {
    commit("CLEAR_SELECTED_CUSTOM_WORKVIEW");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
